<template lang="html">
  <d-select v-model="state" :id="id" @change="callChange($event)" :state="validate">
    <option :value="null">Selecione...</option>
    <option value="AC">Acre</option>
    <option value="AL">Alagoas</option>
    <option value="AP">Amapá</option>
    <option value="AM">Amazonas</option>
    <option value="BA">Bahia</option>
    <option value="CE">Ceará</option>
    <option value="DF">Distrito Federal</option>
    <option value="ES">Espírito Santo</option>
    <option value="GO">Goiás</option>
    <option value="MA">Maranhão</option>
    <option value="MT">Mato Grosso</option>
    <option value="MS">Mato Grosso do Sul</option>
    <option value="MG">Minas Gerais</option>
    <option value="PA">Pará</option>
    <option value="PB">Paraíba</option>
    <option value="PR">Paraná</option>
    <option value="PE">Pernambuco</option>
    <option value="PI">Piauí</option>
    <option value="RJ">Rio de Janeiro</option>
    <option value="RN">Rio Grande do Norte</option>
    <option value="RS">Rio Grande do Sul</option>
    <option value="RO">Rondônia</option>
    <option value="RR">Roraima</option>
    <option value="SC">Santa Catarina</option>
    <option value="SP">São Paulo</option>
    <option value="SE">Sergipe</option>
    <option value="TO">Tocantins</option>
  </d-select>
</template>

<script>

export default {
  name: 'select-state',
  props: {
    model: {
      required: true,
      default: null,
    },
    id: {
      type: String,
      default: 'feInputEstado',
    },
    validate: {
      type: String,
      default: null,
    },
    onChange: {
      type: Function,
      default: () => {},
    },
  },
  computed: {
    state: {
      get() {
        return this.model;
      },
      set(val) {
        this.$emit('update:model', val);
      },
    },
  },
  methods: {
    callChange(event) {
      this.onChange(event);
    },
    callKeyUp() {
      this.onKeyup(this.model);
    },
  },
};
</script>
